import { addDays, startOfDay } from 'date-fns';

import { ContractStatus } from '../entities/contract-status';

export function getContractStatus(
  startDate: Date | undefined,
  endDate: Date | undefined,
  now: Date = new Date(),
): ContractStatus | undefined {
  if (!startDate) {
    return undefined;
  }

  const today = startOfDay(now);
  const start = startOfDay(startDate);

  // Check if contract is currently active
  if (!isContractActive(start, endDate, today)) {
    return ContractStatus.Inactive;
  }

  // Check if contract is expiring soon
  if (endDate && isExpiringSoon(startOfDay(endDate), today)) {
    return ContractStatus.ExpiringSoon;
  }

  return ContractStatus.Active;
}

function isContractActive(
  start: Date,
  endDate: Date | undefined,
  today: Date,
): boolean {
  if (today < start) {
    return false; // Contract hasn't started yet
  }

  if (!endDate) {
    return true; // No end date means ongoing contract
  }

  const end = startOfDay(endDate);
  return today <= end; // Contract is within start/end range
}

function isExpiringSoon(end: Date, today: Date): boolean {
  const thirtyDaysFromNow = addDays(today, 30);
  return end <= thirtyDaysFromNow;
}
